import { render, staticRenderFns } from "./BlockResolver.vue?vue&type=template&id=f6cd2806&"
import script from "./BlockResolver.vue?vue&type=script&lang=ts&"
export * from "./BlockResolver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports